import { CancelUnitButton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/details/components/management/cancel-unit'
import { RestoreUnitButton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/details/components/management/restore-unit'
import { ContactActionsButton } from '@apps-common/components/modals/contact-actions'
import { QRCodeUnitLabelButton } from '@apps-common/components/qr-code/qr-code-unit-label'
import { UNIT_STATUS_ACTIVE, UNIT_STATUS_CANCELLED, UNIT_STATUS_INACTIVE } from '@apps-common/config/unit-filter'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

interface IProps {
  loading: boolean
  unit?: IUnitGenericDetailsModel
}

export const UnitDetailsManagementHeaderOptions: React.FC<IProps> = ({ loading, unit }) => {
  const { unitId, status } = unit || {}

  if (loading || !unit) {
    return null
  }

  return (
    <>
      {(!status || status === UNIT_STATUS_ACTIVE.value || status === UNIT_STATUS_INACTIVE.value) && (
        <div className='flex items-center justify-end gap-[0px] sm:gap-[10px]'>
          <QRCodeUnitLabelButton loading={loading} unitId={unitId} />
          <ContactActionsButton loading={loading} entityId={unitId} />
          <CancelUnitButton loading={loading} unit={unit} />
        </div>
      )}
      {status === UNIT_STATUS_CANCELLED.value && (
        <div className='flex items-center justify-end gap-[5px] sm:gap-[10px]'>
          <ContactActionsButton loading={loading} entityId={unitId} />
          <RestoreUnitButton loading={loading} unit={unit} />
        </div>
      )}
    </>
  )
}
